interface IHotelQuestionApplicableConditionTypes {
  all: string;
  specifiedPlans: string;
}

export const HotelQuestionApplicableConditionTypes: IHotelQuestionApplicableConditionTypes =
  {
    all: "all",
    specifiedPlans: "specified_plans",
  };
